import { thumbnail as thumbnailFunc } from '../utils';

const thumbnail = (imageUrl, format) => thumbnailFunc(imageUrl, format);
export default thumbnail;
